import React from 'react';
import ReactDOM from 'react-dom';
import { Button } from '@components/ui/button';
import { useSessionExpiredModalStore } from 'src/store/session-expired-modal';

const SessionExpiredModal: React.FC = () => {
  const { isOpen, closeModal } = useSessionExpiredModalStore();

  if (!isOpen) {
    return null;
  }

  const handleLogin = () => {
    closeModal();
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  const modalContent = (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-2xl">
        <h2 className="text-xl font-semibold text-gray-900">
          Sorry, but looks like your session has been expired.
        </h2>
        <p className="mt-3 text-sm text-gray-600">
          Please try to login again.
        </p>
        <div className="mt-6 flex justify-center">
          <Button onClick={handleLogin} className="min-w-[140px]">
            Login
          </Button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return null;
  }

  return ReactDOM.createPortal(modalContent, document.body);
};

export default SessionExpiredModal;

